<script setup lang="ts">
import EditGroupMemberDrawer from '@/pages/erp/ds/auth/view/ds-groupMember-drawer.vue'
import type { GroupMemberProperties } from '@/pages/erp/ds/auth/db/ds-groupMember-types'
import Swal from 'sweetalert2'
definePage({
    meta: {
        action: 'manage',
        subject: 'DSGROUPMEMBER',
    },
})

const compId = ref(useStorage('compNo').value)
const groupId = ref()
const member = ref()

// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
    { title: '群組代碼', key: 'groupId' },
    { title: '成員代號', key: 'member' },
    { title: '成員類別', key: 'memberType' },
    { title: '狀態', key: 'status' },
    { title: '失效日期', key: 'expired' },
    { title: '操作', key: 'actions', sortable: false}
]


// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: groupMembersData, execute: fetchGroupMembers } = await useApi<any>(createUrl('/ds/auth/groupMember/searchGroupMember', {
  query: {
    compId,
    groupId,
    member,
    page,
    size,
    orderByCol,
    sortOrder,
  },
}))

const datas = computed((): GroupMemberProperties[] => groupMembersData.value.data.groupMemberPage.content)
const totalDatas = computed(() => groupMembersData.value.data.groupMemberPage.totalElements)

console.log('datas: ', datas)

const isEditDataDrawerVisible = ref(false)
const isNewData = ref(false)
const isCopyData = ref(false)

let voData = {}


const createData = () => {
  isEditDataDrawerVisible.value = true
  isNewData.value = true
  isCopyData.value = false
}

const editData = (groupMemberData: GroupMemberProperties) => {
  voData = groupMemberData
  console.log('editGroupMember: ', voData)
  isEditDataDrawerVisible.value = true
  isNewData.value = false
  isCopyData.value = false
}

const copyData = (groupMemberData: GroupMemberProperties) => {
    voData = groupMemberData
    console.log('copyGroupMember: ', voData)
    isEditDataDrawerVisible.value = true
    isNewData.value = true
    isCopyData.value = true
}

// 👉 Add new data
const addNewData = async (groupMemberData: GroupMemberProperties) => {
  await $api('/ds/auth/groupMember/createGroupMember', {
    method: 'POST',
    body: { groupMember: groupMemberData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '新增成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false
    })
  })

  // refetch data
  fetchGroupMembers()
}

const updateData = async (groupMemberData: GroupMemberProperties) => {
  await $api('/ds/auth/groupMember/updateGroupMember', {
    method: 'PUT',
    body: { groupMember: groupMemberData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false
    })
  })

  // refetch data
  fetchGroupMembers()
}

  // 👉 Delete data
const deleteData = async (groupMemberData: GroupMemberProperties) => {
  const { compId,groupId,member } = groupMemberData
    $swal({
    title: `確定要刪除 ${groupMemberData.member} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
        $api(`/ds/auth/groupMember/deleteGroupMember`, {
        method: 'DELETE',
        query: {
          compId,groupId,member
        }
      }).then(() => {
          $swal({
          position: 'top-end',
          title: "刪除成功",
          timer: 1500,
          icon: "success"
        });

        // refetch Data
        fetchGroupMembers()
      })
    }
  });

}

const clickRow = (event, select) => {
  console.log('clickRow: ', event, select)
  editData(select.item)
}

</script>

<template>
  <!-- 👉 Widgets -->

  <VCard class="mb-6">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>

    <VCardText>
      <VRow>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="compId"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入公司別"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="groupId"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入群組代碼"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="member"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入成員代號"
          />
        </VCol>
      </VRow>
    </VCardText>

    <VDivider />

    <VCardText class="d-flex flex-wrap gap-4">
      <VSpacer />

      <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
        <!-- 👉 Add button -->
        <VBtn
                prepend-icon="tabler-plus"
                @click="createData"
        >
          新增群組成員
        </VBtn>
      </div>
    </VCardText>

    <VDivider />

    <!-- SECTION datatable -->
    <VDataTableServer
            v-model:items-per-page="size"
            v-model:page="currentPage"
            :items="datas"
            :items-length="totalDatas"
            :headers="grid1Headers"
            class="text-no-wrap"
            @update:options="updateOptions"
    >

      <template #item.groupId="{ item }">
          <div class="text-body-1 text-high-emphasis text-capitalize">
              <div class="font-weight-medium ">
                  {{ toCode(item.groupId) }}
              </div>
              <div class="text-sm">
                  {{ toText(item.groupId) }}
              </div>
          </div>
      </template>

      <template #item.member="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.member }}
          </div>
      </template>

      <template #item.memberType="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.memberType }}
          </div>
      </template>

      <template #item.status="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.status }}
          </div>
      </template>

      <template #item.expired="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.expired }}
          </div>
      </template>

      <!-- Actions -->
      <template #item.actions="{ item }">
          <IconBtn @click="editData(item)">
              <VIcon icon="tabler-edit" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >編輯</v-tooltip>
          </IconBtn>
          <IconBtn @click="copyData(item)">
              <VIcon icon="tabler-copy" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >複製</v-tooltip>
          </IconBtn>
          <IconBtn @click="deleteData(item)">
              <VIcon icon="tabler-trash" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >刪除</v-tooltip>
          </IconBtn>
      </template>

      <!-- pagination -->
      <template #bottom>
        <TablePagination
                v-model:page="currentPage"
                v-model:size="size"
                :items-per-page="size"
                :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>
  <!-- 👉 Edit -->
  <EditGroupMemberDrawer
          v-model:isDrawerOpen="isEditDataDrawerVisible"
          :groupMember-data="voData"
          :is-new="isNewData"
          :is-copy="isCopyData"
          @create-data="addNewData"
          @update-data="updateData"
  />

</template>
